<template>
  <modal-template
    ref="modal"
    title="Por favor, faça login no outro sistema"
    type-modal="login_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="toggleLoggedIn">
        <d-form-row>
          <!-- Usuario -->
          <d-col class="form-group">
            <label for="username">Usuário</label>
            <d-form-input
              @keydown.enter="toggleLoggedIn()"
              type="text"
              id="username"
              placeholder="usuário"
              v-model="form.username"
              required
            />
          </d-col>
        </d-form-row>
        <d-form-row>
          <!-- Senha -->
          <d-col class="form-group">
            <label for="username">Senha</label>
            <d-form-input
              @keydown.enter="toggleLoggedIn()"
              type="password"
              id="password"
              placeholder="senha"
              v-model="form.password"
              required
            />
          </d-col>
        </d-form-row>

        <d-row class="login-form__form__control cotrol">
          <d-col cols="12" class="control__error">
            <span v-if="error">E-mail e/ou senha estão incorretos.</span>
          </d-col>

          <d-col cols="12" class="control__send">
            <div class="control__send__button">
              <d-button class="btn btn-md btn-primary">Entrar</d-button>
            </div>
          </d-col>
        </d-row>
      </d-form>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';
import CrossWordsService from '_services/rest/modules/crossword';

export default {
  name: 'Login-modal',
  components: {
    ModalTemplate,
  },
  data() {
    return {
      form: {
        username: null,
        password: null,
      },
      error: false,
      success: false,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    toggleLoggedIn(e) {
      e.preventDefault();
      CrossWordsService.login(this.form)
        .then(() => {
          this.error = false;
          this.success = true;
          this.setToggle({ type: 'login_modal', bool: false });
        })
        .catch(() => {
          this.error = true;
          this.form.password = '';
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
